import { DateTime } from 'luxon';
const standardizeDate = (date) => {	
    const [month, day, year] = date.toLocaleDateString("en-US").split("/")
    return DateTime.utc(parseInt(year),parseInt(month),parseInt(day)).toISODate();
}

export default standardizeDate;